import React from "react";
import { useSite } from "../theme/ThemeProvider";

const MapEmbed = ({ className = "map" }) => {
  const site = useSite();
  const src = `https://www.google.com/maps?q=${encodeURIComponent(site.address.mapsQuery)}&output=embed&hl=tr`;
  return (
    <div className={className}>
      <iframe title="Harita" src={src} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
    </div>
  );
};

export default MapEmbed;
